import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import 'prop-types';
import { jsx } from '@emotion/core';
import { useThemeContext } from '../ThemeProvider/ThemeContext.js';
import GlyphClose from '../../svg/GlyphClose.js';
import Button from '../Buttons/Button.js';
import modalStyleObject from '../../styles/modal.js';
import { flex } from '../../styles/layout/flex.js';
import { flexAlignCenter } from '../../styles/layout/flexAlignCenter.js';
import { dlsBrightBlueBg } from '../../styles/colorsDls/dlsBrightBlueBg.js';
import { dlsWhite } from '../../styles/colorsDls/dlsWhite.js';
import { focusLight } from '../../styles/focus/focusLight.js';
import { textAlignCenter } from '../../styles/text/textAlignCenter.js';
import { useModalContext } from './ModalContext.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ModalHeader = function ModalHeader(_ref) {
  var onClose = _ref.onClose,
      dismissible = _ref.dismissible,
      closeButtonLabel = _ref.closeButtonLabel,
      theme = _ref.theme,
      children = _ref.children,
      closeButtonProps = _ref.closeButtonProps,
      otherProps = _objectWithoutProperties(_ref, ["onClose", "dismissible", "closeButtonLabel", "theme", "children", "closeButtonProps"]);

  var themeTokens = useThemeContext();
  var modalContext = useModalContext();

  var styleObject = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, modalStyleObject.modal_header), flex), flexAlignCenter), {}, {
    backgroundColor: themeTokens.primaryColor || dlsBrightBlueBg.backgroundColor
  }, dlsWhite), textAlignCenter);

  return jsx("header", _extends({
    css: _objectSpread(_objectSpread({}, styleObject), theme)
  }, otherProps), children, dismissible && jsx(Button, _extends({}, closeButtonProps, {
    theme: focusLight,
    onClick: onClose || modalContext.onClose,
    "aria-label": closeButtonLabel
  }), jsx(GlyphClose, {
    size: "lg"
  })));
};

ModalHeader.defaultProps = {
  onClose: null,
  dismissible: true,
  closeButtonLabel: 'Close',
  theme: undefined,
  closeButtonProps: {}
};

export default ModalHeader;
